import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { word } from "../word.js";
import { Col, Row, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import Button from "../components/Button/Button.js";
import Api from "../Api.js";
import { useLocation, useParams } from "react-router-dom";
import qs from "query-string";

function EditManager({ onHide, show, setInfo, information }) {
    const { id } = useParams();  // Get type from URL
    const location = useLocation()
    const query = qs.parse(location.search, { arrayFormat: 'comma' });
    const [imagePreviewUrl, setImagePreviewUrl] = useState("");
    const [image, setImage] = useState(null);
    const [submited, setSubmited] = useState(false);
    const [form, setForm] = useState([
        { key: 'user.first_name', value: information?.user?.first_name || "", errorMessage: "name_error", type: "text", valid: !!information?.user?.first_name },
        { key: 'user.last_name', value: information?.user?.last_name || "", errorMessage: "name_error", type: "text", valid: !!information?.user?.last_name },
        { key: 'profession', value: information?.profession || "", errorMessage: "name_error", type: "text", valid: !!information?.profession },
        { key: 'phone', value: information?.phone || "", errorMessage: "phone_error", type: "phone", valid: !!information?.phone },
    ]);
    const login = useSelector((state) => state.manager.employee);

    const [is_lecturer,setIsLecturer] = useState(information?.is_lecturer)

    const handleSubmit = async () => {
        try {
            setSubmited(true);
            let formData = new FormData();
            if (image) formData.append("image", image, image.name);
            for (let item of form) {
                if ((!item.valid || item.value.length === 0) && item.key !== "profession") return;
                formData.append(item.key, item.value);
            }

            formData.append("user.email", information.user.email);
            formData.append("is_lecturer", +is_lecturer || 0);
            if (query && query.manager) {
                await Api.managerUpdate(formData, 'manager', id)
                const { data } = await Api.managerUpdateGet('manager', id)
                setInfo(data)
            } else {
                await Api.managerUpdate(formData, 'accountant', id)
                const { data } = await Api.managerUpdateGet('accountant', id);
                setInfo(data)
            }
            onHide()
        } catch (e) {

        }
    };

    const handleChange = (index, value) => {
        let updatedForm = [...form];
        updatedForm[index].value = value;
        updatedForm[index].valid = validateField(updatedForm[index]);
        setForm(updatedForm);
    };

    const validateField = (item) => {
        if (item.type === "text") {
            return item.value.length >= 3;
        } else if (item.type === "phone") {
            return /^[0-9]/.test(item.value) && item.value[0] === '0' && item.value.length === 9;
        }
        return true;
    };
    return (
        <Modal
            {...{ onHide, show }}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                    className="w-100 d-flex flex-row justify-content-between">
                    <span />
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide} />
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <Row className="d-flex justify-content-around">
                        <Col xs={12} sm={10}>
                            <div className='add-img'>
                                <label>
                                    <input type="file" onChange={(e) => {
                                        let file = e.target.files[0];
                                        if (file) {
                                            let reader = new FileReader();
                                            reader.onloadend = () => {
                                                setImagePreviewUrl(reader.result);
                                                setImage(file);
                                            };
                                            reader.readAsDataURL(file);
                                        }
                                    }} />
                                    <span className='add-span'>{word.add_picture}</span>
                                    <div className='add-round-img' style={{ backgroundImage: `url(${imagePreviewUrl || information?.image || ''})` }}>
                                        {!imagePreviewUrl && !information?.image && <i className="fas fa-camera" />}
                                    </div>
                                </label>
                                {form.map((item, index) => {
                                    if(query.manager && item.key === "profession" ){
                                        return;
                                    }
                                    return(
                                    <Form.Group className='justify-content-center form-group' key={index}>
                                        <Form.Control
                                            type={item.type}
                                            className={!item.valid && submited ? "form-control is-invalid" : "form-control"}
                                            autoComplete="off"
                                            onChange={(e) => handleChange(index, e.target.value)}
                                            placeholder={word[item.key]}
                                            value={item.value || ""}
                                        />
                                        {!item.valid && submited && <div className='validation'>{word[item.errorMessage]}</div>}
                                    </Form.Group>
                                )})}
                                {[2,86,1024,1734,1918].includes(login.user_id)?<Form.Group className='justify-content-center form-group'>
                                    <label className='d-flex align-items-center'>
                                    Դասընթացներին ներգրավված անձ
                                        <input style={{display:'inline-block',width:16, height:16, marginLeft:10}} type="checkbox" checked={is_lecturer} onChange={(ev) => setIsLecturer(ev.target.checked)}/>
                                    </label>
                                </Form.Group>:null}
                            </div>
                        </Col>
                    </Row>
                    <Row className="d-flex ">
                        <Col xs={12} sm={10} className="d-flex align-items-end">
                            <Button buttonStyle="blue-button" onChangeValue={handleSubmit} title={word.confirmed} />
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default EditManager;